import React, { useMemo } from 'react';
import { containsKeywordInTable } from '@/CADUtils/functions/containsKeyword';

const OffenseInformationSection = ({ offence, isRedactedReport, redactingData }) => {
  const parsedOffence = useMemo(() => {
    try {
      return JSON.parse(offence || '[]');
    } catch (error) {
      return [];
    }
  }, [offence]);

  if (!Array.isArray(parsedOffence) || parsedOffence.length === 0) {
    return null;
  }

  return (
    <div className="container ">
      <h6 className=" text-dark mt-2">Offense Information</h6>
      <div className="col-12">
        {parsedOffence.map((item, key) => (
          <div className="row  mb-2 px-3 " key={key}>
            <div className="col-5 col-md-5 col-lg-5 mt-1">
              <div className="text-field">
                <input
                  type="text"
                  className="readonlyColor"
                  name="DocFileName"
                  required
                  readOnly
                  value={item.FBIID_Description}
                />
                <label htmlFor="" className="new-summary">TIBRS Code</label>
              </div>
            </div>
            <div className="col-5 col-md-5 col-lg-7 mt-1">
              <div className="text-field">
                <input
                  type="text"
                  className={`readonlyColor ${isRedactedReport && containsKeywordInTable(item.OffenseName_Description, 'FullDescription', 'Table1', redactingData) ? 'redacted' : ''}`}
                  name="DocFileName"
                  required
                  readOnly
                  value={item.OffenseName_Description}
                />
                <label htmlFor="" className="new-summary">Offense Code/Name</label>
              </div>
            </div>
            <div className="col-5 col-md-5 col-lg-5 mt-4">
              <div className="text-field">
                <input
                  type="text"
                  className="readonlyColor"
                  name="DocFileName"
                  required
                  readOnly
                  value={item.PrimaryLocation}
                />
                <label htmlFor="" className="new-summary">Primary Location</label>
              </div>
            </div>
            <div className="col-2"></div>
            <div className="col-5 col-md-5 col-lg-5 mt-4 ">
              <div className="text-field">
                <input
                  type="text"
                  className="readonlyColor"
                  name="DocFileName"
                  required
                  readOnly
                  value={item.SecondaryLocation}
                />
                <label htmlFor="" className="new-summary">Secondary Location</label>
              </div>
            </div>
            <div className="col-2 col-md-2 col-lg-2 mt-2 pt-1">
              {item.AttemptComplete == 'A' ? (
                <div className="form-check  ">
                  <input className="form-check-input mt-1" type="checkbox" checked={true} name="AttemptComplete" id="flexRadioDefault1" />
                  <label className="form-check-label" htmlFor="flexRadioDefault2">
                    Attempted
                  </label>
                </div>
              ) : (
                <div className="form-check  ">
                  <input className="form-check-input mt-1" type="checkbox" value={false} checked={false} onChange={(e) => { e.preventDefault(); }} name="AttemptComplete" id="flexRadioDefault1" />
                  <label className="form-check-label" htmlFor="flexRadioDefault2">
                    Attempted
                  </label>
                </div>
              )}
            </div>
            <div className="col-2 col-md-2 col-lg-2 mt-2 pt-1">
              {item.AttemptComplete === 'C' ? (
                <div className="form-check  ">
                  <input className="form-check-input mt-1" type="checkbox" checked={true} name="AttemptComplete" id="flexRadioDefault2" />
                  <label className="form-check-label" htmlFor="flexRadioDefault2">
                    Completed
                  </label>
                </div>
              ) : (
                <div className="form-check  ">
                  <input className="form-check-input mt-1" type="checkbox" value={false} checked={false} onChange={(e) => { e.preventDefault(); }} name="AttemptComplete" id="flexRadioDefault2" />
                  <label className="form-check-label" htmlFor="flexRadioDefault2">
                    Completed
                  </label>
                </div>
              )}
            </div>
            <div className="col-2 col-md-2 col-lg-2 mt-2 pt-1">
              {
                item.AttemptComplete === "U" ?
                  <div className="form-check  ">
                    <input className="form-check-input mt-1" type="checkbox" checked={true} name="AttemptComplete" id="flexRadioDefault3" />
                    <label className="form-check-label" htmlFor="flexRadioDefault3">
                      Unfounded
                    </label>
                  </div>
                  :
                  <div className="form-check  ">
                    <input className="form-check-input mt-1" type="checkbox" value={false} checked={false} onChange={(e) => { e.preventDefault(); }} name="AttemptComplete" id="flexRadioDefault3" />
                    <label className="form-check-label" htmlFor="flexRadioDefault3">
                      Unfounded
                    </label>
                  </div>
              }
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OffenseInformationSection;
